import { fromJS } from 'immutable';

import * as types from '../actions/actionTypes';

export const initialState = fromJS({
  reports: [],
  loading: false
});

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_REPORTS: {
      return state.set('loading', true);
    }
    case types.FETCH_REPORTS_SUCCESS: {
      const newState = state.set('loading', false);
      return newState.set('reports', fromJS(action.reports));
    }
    case types.FETCH_REPORTS_ERROR: {
      return state.set('loading', false);
    }
    default: {
      return state;
    }
  }
};

export default reportReducer;



// WEBPACK FOOTER //
// ./src/reducers/reportReducer.js